import { Components, Theme } from "@mui/material";

export const muiPaper: Components<Omit<Theme, "components">> = {
  MuiPaper: {
    defaultProps: {
      variant: "outlined"
    }
  }
};
